/**
 * Cart shipping calculator init — after jQuery, Handlebars, countries.js, shopify_common.js,
 * and shopify-cart-shipping-calculator.js (footer load order on cart template).
 */
(function () {
  var initialized = false;
  var formGuardsBound = false;

  /** Shipping fields live inside #cartform; Enter must not POST /cart (reload + collapsed accordion). */
  function bindShippingCalculatorFormGuards() {
    if (formGuardsBound) return;
    var calc = document.getElementById("shipping-calculator");
    var cartform = document.getElementById("cartform");
    if (!calc) return;
    formGuardsBound = true;

    function triggerGetRates() {
      var btn = calc.querySelector(".get-rates");
      if (btn && !btn.disabled) btn.click();
    }

    calc.addEventListener("keydown", function (e) {
      if (e.key !== "Enter") return;
      var tag = e.target && e.target.tagName;
      if (tag !== "INPUT" && tag !== "SELECT") return;
      e.preventDefault();
      e.stopPropagation();
      triggerGetRates();
    });

    if (cartform) {
      cartform.addEventListener(
        "submit",
        function (e) {
          var active = document.activeElement;
          if (!active || !calc.contains(active)) return;
          e.preventDefault();
          e.stopPropagation();
          triggerGetRates();
        },
        true
      );
    }
  }

  function shippingConfig() {
    var strings = (window.theme && window.theme.strings) || {};
    var cfg = {
      submitButton: strings.shippingCalcSubmitButton || "Calculate shipping",
      submitButtonDisabled:
        strings.shippingCalcSubmitButtonDisabled || "Calculating…",
      moneyFormat:
        strings.shippingCalcMoneyFormat ||
        (window.Shopify && Shopify.money_format) ||
        "${{amount}}",
    };
    if (strings.shippingCalcCustomerIsLoggedIn) {
      cfg.customerIsLoggedIn = true;
    }
    return cfg;
  }

  function initShippingCalculator() {
    if (initialized) return true;
    if (typeof jQuery === "undefined") return false;
    if (typeof Handlebars === "undefined") return false;
    if (
      !window.Shopify ||
      !Shopify.Cart ||
      !Shopify.Cart.ShippingCalculator ||
      typeof Shopify.Cart.ShippingCalculator.show !== "function"
    ) {
      return false;
    }

    if (!jQuery("#shipping-calculator").length) return true;

    Shopify.Cart.ShippingCalculator.show(shippingConfig());
    initialized = true;
    return true;
  }

  function tryInit(attempt) {
    bindShippingCalculatorFormGuards();
    if (initShippingCalculator()) return;
    if (attempt > 40) return;
    setTimeout(function () {
      tryInit(attempt + 1);
    }, 150);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      tryInit(0);
    });
  } else {
    tryInit(0);
  }
})();
